import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F31.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame31() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);


        return (
            <div className="F31_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F31_entryBox">
                    <div className="F31_paragraph">
                        {language === 'english' ?
                            <p className="F31_paragraphEnglish">Saira is relieved to hear that periods are a normal occurrence. Saira tells her teacher that since she had no idea about her first periods, she had locked herself in her room this morning.</p>
                            :
                            <p className="F31_paragraphUrdu">سائرہ کو یہ جان کر بہت اطمینان ہو جاتا ہے کہ ماہواری ایک معمولی طبعی عمل ہے۔ سائرہ اپنی ٹیچر کو بتاتی ہے کہ اس نے آج صبح اپنے آپ کو کمرے میں بند کر لیا تھا کیونکہ اسکو ماہواری کے بارے میں کچھ نہیں پتا تھا۔</p>
                        }
                    </div>

                    <div className="F31_timeline">
                        <div className='F31_timelineBar'>
                            <div className='F31_timelineFill'></div>
                            <span className='F31_timelineText'>7/19</span>
                        </div>
                    </div>

                    <div className="F31_nextFrames">
                        <div className="F31_nextFrame1"></div>
                        <div className="F31_nextFrame2"></div>
                        <div className="F31_nextFrame3"></div>
                    </div>

                    <div className='F31_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(7)) }} className='F31_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
}

export default Frame31;